import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap } from "lucide-react";
import { SubNav, ASSESSMENT_SUBNAV } from "@/components/SubNav";
import { JP } from "@/components/JP";
import { usePrefs } from "@/context/PrefsContext";
import { api } from "@/lib/api";

export default function SkillsAssessment() {
  const { t } = usePrefs();
  const [plans, setPlans] = useState(null);
  useEffect(() => { api.get("/plans", { params: { track: "skills" } }).then((r) => setPlans(r.data)); }, []);
  return (
    <div className="mx-auto max-w-2xl fade-up" data-testid="skills-assessment-page">
      <p className="font-jpserif text-sm tracking-[0.3em] text-muted-foreground">技能評価</p>
      <h1 className="mt-3 font-jpserif text-4xl sm:text-5xl">Assessment Keterampilan</h1>
      <div className="mt-5"><SubNav items={ASSESSMENT_SUBNAV} testid="assessment-subnav" /></div>
      <p className="mt-5 text-base leading-relaxed text-muted-foreground">Evaluasi 30 soal (3 batch × 10, dengan jeda maskot Yutaka) dari seluruh pelajaran modul keterampilan. Lulus ≥ 60%.</p>
      {!plans ? <p className="mt-6 text-sm text-muted-foreground">{t("loading")}</p> : (
        <div className="mt-6 space-y-3">
          {plans.map((p) => { const exam = p.modules.find((m) => m.kind === "exam"); return (
            <div key={p.id} className="soft-card flex flex-wrap items-center gap-4 p-5" data-testid={`skills-exam-${p.id}`}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary/10 text-secondary"><GraduationCap className="h-5 w-5" /></span>
              <div className="min-w-0 flex-1">
                <p className="text-xs uppercase tracking-wide text-muted-foreground">{p.subtitle}</p>
                <JP text={exam?.title_jp || p.title} as="p" className="text-base font-medium" mode="off" />
                <p className="text-sm text-muted-foreground">{p.done}/{p.total} tahap selesai{exam?.best_score != null && ` · skor terbaik ${exam.best_score}%`}</p>
              </div>
              {exam && <Link data-testid={`skills-exam-start-${p.id}`} to={`/test/${exam.id}`} className="inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-transform hover:-translate-y-0.5">{t("begin")}<ArrowRight className="h-4 w-4" /></Link>}
            </div>
          ); })}
          <div className="soft-card flex items-center justify-between gap-3 border-dashed p-5 opacity-80" data-testid="skills-exam-logistics"><div><p className="text-base font-medium">Logistic & Warehouse · 物流・倉庫</p><p className="text-sm text-muted-foreground">Evaluasi menyusul bersama modulnya.</p></div><span className="rounded-full bg-amber-100 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-amber-800">Coming soon</span></div>
        </div>
      )}
    </div>
  );
}
